import type { AssignmentArea } from "./types";

/** Closed ring with at least 4 positions (incl. repeated first/last). */
export function hasValidAssignmentPolygon(area: AssignmentArea | undefined | null): boolean {
    const ring = area?.coordinates?.[0];
    return Array.isArray(ring) && ring.length >= 4;
}
